<template>
  <div id="">
    <router-view />
    <Alert/>
  </div>
</template>

<script>
import Alert from "@/components/UI/Modal/Alert.vue";

export default {
  components: {
    Alert
  },

  created() {
    this.$store.dispatch('user/init')

  },

  mounted() {
    document.querySelector('meta[name="viewport"]').setAttribute(
      'content',
      'width=device-width, initial-scale=0.8'
    );
    document.body.style.zoom = "80%";
    
    this.$store.dispatch('device/updateDevice');
    this.$store.dispatch('device/watchResize');
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('pagehide', this.handleBeforeUnload);

    setTimeout(()=>{
      this.$store.dispatch('statistic/START_STATISTIC', 
      {
        landing_settings_uid: this.$store.getters['landing/landingSettings'].uid
      })
    }, 500)
  },

  unmounted() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('pagehide', this.handleBeforeUnload);
  },

  methods: {
    handleBeforeUnload(event) {
      try {
        this.$store.dispatch('statistic/SEND_SESSION_END');
      } catch (e) {
        console.warn('failed dispatch SEND_SESSION_END', e);
      }
    }
  },

  computed: {
    device() {
      return this.$store.getters['device/deviceInfo'];
    },
    isMobile() {
      return this.$store.getters['device/isMobile'];
    }
  }
}
</script>

<style scoped>

</style>